import styled from 'styled-components'
import Layout from '..'

const { Sider } = Layout
const siderWidth = 250

export default styled(Sider)`
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.sider};

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .sider-logo {
    display: block;
    width: ${siderWidth - 50}px;

    padding: ${({ theme }) => theme.spacing.spacing24}px;
    margin-bottom: ${({ theme }) => theme.spacing.spacing24}px;
    margin-left: auto;
    margin-right: auto;
  }

  .account-card {
    background-color: ${({ theme }) => theme.colors.primaryFaded};
    border: 1px solid ${({ theme }) => theme.colors.primaryLight};
    margin: ${({ theme }) => theme.spacing.spacing16}px ${({ theme }) => theme.spacing.spacing8}px;
    cursor: pointer;
  }
`
